import { useUser } from '@/hooks/use-user';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { getInvitePath, resolveSafeRedirectPath } from '@/lib/invite-flow';

interface GuestGuardProps {
  children: React.ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('inviteCode');
  const redirectPath = resolveSafeRedirectPath(searchParams.get('redirect'));
  const { user, isLoading } = useUser();

  useEffect(() => {
    if (!isLoading && user) {
      if (inviteCode) {
        navigate(getInvitePath(inviteCode), { replace: true });
        return;
      }
      navigate(redirectPath || '/dashboard', { replace: true });
    }
  }, [isLoading, user, navigate, inviteCode, redirectPath]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (user) {
    return null;
  }

  return <>{children}</>;
}
